import React, { useCallback } from 'react';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { getCssClassForIcon, AmplifyIcons } from '../../../../constants/shared/IconsConstants';
import { toolTips } from '../../../../api/demoMode/reading/demoModeActions';
import './DemoTourMap.scss';

const DemoTourMap = ({ activeStep, visitedTourSteps }) => {
    const areAllStepsVisited = useCallback(
        tourStepIdsInMap => {
            if (isEmpty(tourStepIdsInMap)) {
                return false;
            }

            return tourStepIdsInMap.every(tourId => visitedTourSteps.includes(tourId));
        },
        [visitedTourSteps],
    );

    const handleFilterTourInMap = useCallback(demoStepOrder => {
        return demoStepOrder.filter(tourStepId => {
            const step = toolTips.steps[tourStepId];
            return step?.isInMap;
        });
    }, []);
    return (
        <div className="flex-row" id="demo-tour-map">
            {toolTips.sectionOrder.map((tourSectionId, sectionNum) => {
                const demoSection = toolTips.sections[tourSectionId];
                const sectionStepIds = handleFilterTourInMap(demoSection.stepOrder);

                const isTourSectionCompleted = areAllStepsVisited(sectionStepIds);
                const prevTourSection =
                    sectionNum > 0 ? toolTips.sections[toolTips.sectionOrder[sectionNum - 1]] : {};
                const prevTourStepIds = !isEmpty(prevTourSection)
                    ? handleFilterTourInMap(prevTourSection.stepOrder)
                    : [];
                const checkActiveStep = (isStepActive, tourStepId) => {
                    if (isStepActive) {
                        return 'active ';
                    }
                    return visitedTourSteps.includes(tourStepId) ? 'completed' : '';
                };
                return (
                    <div
                        className={`flex-column demo-tour-section 
                            ${areAllStepsVisited(prevTourStepIds) ? 'prev-completed' : ''}`}
                        data-tour-section={tourSectionId}
                        key={tourSectionId}
                    >
                        <div
                            className={`flex-center demo-tour-section-num ${
                                isTourSectionCompleted ? 'completed' : ''
                            }`}
                        >
                            {isTourSectionCompleted ? (
                                <i
                                    className={`${getCssClassForIcon(
                                        /* Added this and other icons from new style guide from  
                                        Aqua react in https://github.com/amplify-education/aqua-dashboard/blob/master/src/root/Dashboard/shared/constants/icons.constants.js
                                        Can be found in file src/constants/shared/Icons.constants.js
                                         */
                                        AmplifyIcons.CHECKMARK,
                                    )} rhythm-icon`}
                                />
                            ) : (
                                sectionNum + 1
                            )}
                        </div>
                        <div className="demo-tour-section-title">{demoSection.title}</div>
                        <div className="demo-tour-section-steps">
                            {sectionStepIds.map(tourStepId => {
                                const isStepActive = activeStep === tourStepId;
                                return (
                                    <div
                                        className="flex-row demo-tour-section-step"
                                        data-tour-step-id={tourStepId}
                                        key={tourStepId}
                                    >
                                        <div
                                            className={`demo-tour-section-step-circle ${checkActiveStep(
                                                isStepActive,
                                                tourStepId,
                                            )}`}
                                        />
                                        <div
                                            className={`demo-tour-section-step-title ${
                                                isStepActive ? 'active ' : ''
                                            }`}
                                        >
                                            {toolTips.steps[tourStepId].title}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
DemoTourMap.defaultProps = {
    activeStep: '',
    visitedTourSteps: [],
};

DemoTourMap.propTypes = {
    activeStep: PropTypes.string,
    visitedTourSteps: PropTypes.array,
};
export default DemoTourMap;
